import React from 'react'
import { ProjectProvider } from './Context'
import { Layout } from './layout'

export const ProjectPage = () => {
  return (
    <ProjectProvider>
      <Layout />
    </ProjectProvider>
  )
}
